var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "99px",
    viewBox: "0 0 80 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationEmpty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifications-empty-state",
    transform: "translate(-1278.000000, -136.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1078.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifications",
    transform: "translate(14.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(119.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/home/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39614561,83.1656082 C-1.7987152,83.1656082 -1.7987152,71.8580036 5.39614561,71.8580036 C11.2205567,71.8580036 11.5631692,49.9723172 11.5631692,42.312327 C11.5631692,24.074255 21.8415418,13.4961733 33.490364,10.9428432 C31.4346895,5.83618303 34.8608137,0 40,0 C45.1391863,0 48.5653105,5.83618303 46.509636,10.9428432 C58.1584582,13.4961733 68.4368308,24.074255 68.4368308,42.312327 C68.4368308,49.9723172 68.7794433,71.8580036 74.6038544,71.8580036 C81.7987152,71.8580036 81.7987152,83.1656082 74.6038544,83.1656082 L5.39614561,83.1656082 Z M47.5194375,86.9565217 C50.8614097,92.0631819 46.6839444,98.6288878 40,98.6288878 C33.3160556,98.6288878 29.1385903,92.0631819 32.4805625,86.9565217 L47.5194375,86.9565217 Z",
    id: "icNotificationEmpty"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationEmpty);
export default __webpack_public_path__ + "static/media/icNotificationEmpty.28c6167eb8586071d3196bbdabf9f3fa.svg";
export { ForwardRef as ReactComponent };